<template>
  <div class="">
    <div class="img_box">
      <p
        class="img_box_p"
        @click="getImgBox(index)"
        :class="imgIndex == index ? 'active' : ''"
        v-for="(item, index) in listImg"
        :key="index"
      >
        {{ item.name }}
      </p>
    </div>
    <p class="img_box_mesg" v-for="(item, index) in picList">
      <img :src="item.url" alt="" />
    </p>
    <el-empty v-if="picList.length==0" description="暂无图片"></el-empty>
  </div>
</template>

<script>
export default {
  props:{
    specification:Object,
  },
  data() {
    return {
      imgIndex: 0,
      listImg: [
        {
          id: 1,
          name: "实物图",
        },
        {
          id: 2,
          name: "尺寸图",
        },
        {
          id: 3,
          name: "电路图",
        },
        {
          id: 4,
          name: "曲线图",
        },
      ],
      picList: []
    };
  },
  watch: {
    specification: {
      handler(val) {
        this.picList = val.entityImages
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    getImgBox(index) {
      this.imgIndex = index;
      if(index == 0) {
        this.picList = this.specification.entityImages;
      }
      else if(index== 1) {
        this.picList = this.specification.sizeImages;
      }
      else if(index == 2) {
        this.picList = this.specification.circuitImages;
      }
      else if(index == 3) {
        this.picList = this.specification.lineImages;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.img_box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  margin-bottom: 40px;
  .img_box_p {
    text-align: center;
    border: 1px solid #333;
    color: #333;
    border-radius: 4px;
    padding: 8px;
    min-width: 110px;
    margin: 0 40px;
    cursor: pointer;
    &:hover {
      color: #169999;
      border: 1px solid #169999;
    }
  }
  .active {
    color: #169999;
    border: 1px solid #169999;
  }
}
.img_box_mesg {
  margin: 0 70px;
  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/components/productImg.vue